import { createContext } from "react";

const ServiciosContext = createContext({});

export default ServiciosContext;
